export const parseMessageForTarget = (message) => {
  let parsedMessage = null;
  try {
    const parsed = JSON.parse(message.message);
    const { target, message: m } = parsed;
    if (target === undefined || m === undefined) {
      parsedMessage = message;
    } else {
      parsedMessage = {
        ...message,
        target,
        message: m,
      };
    }
  } catch (error) {
    parsedMessage = message;
  }
  return parsedMessage;
};
